import React from 'react';
import dayjs from 'dayjs';
import { DateFormats, FmtpErrorCode, FmtpError } from '@lanterds/types';
import {
    CONTACT_SUPPORT_MESSAGE,
    GENERAL_ERROR_ICON,
    GENERAL_ERROR_MESSAGE,
    GENERAL_ERROR_TITLE,
    NETWORK_CONNECTION_ERROR_ICON,
    SupportEmail,
} from 'src/util/constants';
import './GeneralError.scss';
import { useRouteError } from 'react-router-dom';

export default function GeneralError({
    title = GENERAL_ERROR_TITLE,
    icon = GENERAL_ERROR_ICON,
    message = GENERAL_ERROR_MESSAGE,
    supportMessage = CONTACT_SUPPORT_MESSAGE,
}: {
    title?: string;
    icon?: string;
    message?: string;
    supportMessage?: string;
}) {
    const today = dayjs().format(DateFormats.ShortDateTime);
    const href = `mailto:${SupportEmail}?subject=Parcel%20Search%Issue?body=URL:%20${window.location.href};%20Time:%20${today}`;

    let detail: string | null = null;

    const error = useRouteError() as Error;

    if (error) {
        console.error(error);
    }

    if (error?.message === 'Failed to fetch') {
        title = 'Network Error';
        icon = NETWORK_CONNECTION_ERROR_ICON;
        const failedToFetchErrorCode: FmtpErrorCode = 'SHU070';
        const errorMessage = `${error.message} resource.`;
        detail = `"${failedToFetchErrorCode} - ${errorMessage}"`;
    }

    if (error?.name === 'FmtpError') {
        const { memo, errorCode } = error as FmtpError;
        detail = `"${errorCode ? `${errorCode} - ` : ''}${memo}"`;
    }

    return (
        <div className="general-error">
            <h3 className="general-error__title">
                <span className="material-icons">{icon}</span>
                <span className="general-error__title-text">{title}</span>
            </h3>
            <div className="general-error__body">
                <p>{message}</p>
                <p>{detail}</p>
                <p>
                    {supportMessage}
                    <a href={href} target="_blank" rel="noreferrer">
                        {SupportEmail}
                    </a>
                </p>
            </div>
        </div>
    );
}
